module.exports = __webpack_public_path__ + "img/witness-bgc369221.c369221d.png";